import axios from 'axios';

/**
 * Copyright 2024, IntraLinks, Inc, All rights reserved.
 */
var axiosInstance = axios.create({
  baseURL: '',
  withCredentials: true
});
var notificationBaseUrl = '/v3/apis/inapp-delivery/inApp/notifications';
var notificationUpdateURL = '/v3/apis/inapp-delivery/inApp/notifications?status=read';

export { axiosInstance as default, notificationBaseUrl, notificationUpdateURL };
